import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Box, 
  useTheme,
} from '@mui/material';

import { usePagination } from '@frontend/features/common/components/Table';
import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { ListContentLayout } from '@frontend/features/common/components/ListContentLayout';
import {
  useGetHotelDestinations,
} from '@frontend/features/hotel-content-manager/queries';
import { HotelDestinationResponse } from '@bandido/shared/interfaces';
import { InfoLanguage, OrderOptionsValues } from '@bandido/shared/enums';

export const DestinationsView = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const pagination = usePagination();
  const [searchText, setSearchText] = useState('');
  const { data: destinations, isLoading: isLoadingDestinations } = useGetHotelDestinations({
    searchText,
    currentPage: pagination.page,
    pageSize: pagination.rowsPerPage,
    sort: 'id',
    order: OrderOptionsValues.asc
  });

  return (
    <>
      <ListLayout 
        title={t('hotelContent.management.destinations.title') || 'Destinations'} 
        subtitle={t('hotelContent.management.destinations.subtitle') || 'Manage and view destinations'}
      >
        <ListContentLayout
          pagination={pagination}
          stickyHeader
          onSearchChange={(value: string) => {
            setSearchText(value);
          }}
          columns={[
            {
              id: 'code',
              label: t('hotelContent.management.destinations.table.code'),
              align: 'left',
              maxWidth: 100
            },
            {
              id: 'supplierName',
              label: t('hotelContent.management.destinations.table.supplierName'),
              align: 'left',
              minWidth: 100
            },
            {
              id: 'type',
              label: t('hotelContent.management.destinations.table.type'),
              align: 'left',
              minWidth: 100
            },
            {
              id: '-',
              label: t('hotelContent.management.destinations.table.texts'),
              align: 'left',
              format: (_, item) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  <Box sx={{ fontSize: '0.875rem' }}>
                    {`${InfoLanguage.English}: ${(item as HotelDestinationResponse).hierarchyEnglish || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Spanish}: ${(item as HotelDestinationResponse).hierarchySpanish || t('common.notValueFound')}`}
                  </Box>
                  <Box sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                    {`${InfoLanguage.Portuguese}: ${(item as HotelDestinationResponse).hierarchyPortuguese || t('common.notValueFound')}`}
                  </Box>
                </Box>
              ),
            }
          ]}
          isLoading={isLoadingDestinations}
          data={{
            key: 'id',
            items: destinations?.items || [],
            totalCount: destinations?.count || 0,
          }}
        />
      </ListLayout>
    </>
  );
};
